const BACKEND_URL = window.location.hostname === 'localhost' 
  ? process.env.REACT_APP_BACKEND_URL 
  : window.location.origin;

const PLANS = [
  {
    id: 'free',
    name: 'Starter',
    price: '$0',
    period: '/month',
    description: 'Perfect for getting started',
    isPopular: false,
    comingSoon: false,
    buttonText: 'Get Started Free',
    buttonVariant: 'outline',
    features: [
      { included: true, text: 'Up to <strong>5 students</strong>' },
      { included: true, text: 'Class scheduling' },
      { included: true, text: 'Attendance tracking' },
      { included: true, text: 'Basic payment recording' },
      { included: true, text: 'Parent portal access' },
      { included: false, text: 'Homework management' },
      { included: false, text: 'Course outlines' },
      { included: false, text: 'Custom email templates' }
    ]
  },
  {
    id: 'basic',
    name: 'Professional',
    price: '$29',
    period: '/month',
    description: 'For growing tutoring businesses',
    isPopular: true,
    comingSoon: true,
    buttonText: 'Start 14-Day Free Trial',
    buttonVariant: 'primary',
    features: [
      { included: true, text: 'Up to <strong>50 students</strong>' },
      { included: true, text: 'Everything in Starter' },
      { included: true, text: 'Homework management' },
      { included: true, text: 'Course outlines' },
      { included: true, text: 'Custom email templates' },
      { included: true, text: 'Stripe payment integration' },
      { included: true, text: 'Digital waivers' },
      { included: true, text: 'Priority email support' }
    ]
  },
  {
    id: 'advanced',
    name: 'Enterprise',
    price: '$49',
    period: '/month',
    description: 'For tutoring centers & teams',
    isPopular: false,
    comingSoon: true,
    buttonText: 'Contact Sales',
    buttonVariant: 'outline',
    features: [
      { included: true, text: '<strong>Unlimited students</strong>' },
      { included: true, text: 'Everything in Professional' },
      { included: true, text: 'Multiple tutor accounts' },
      { included: true, text: 'Advanced analytics' },
      { included: true, text: 'White-label branding' },
      { included: true, text: 'API access' },
      { included: true, text: 'Dedicated account manager' },
      { included: true, text: 'Phone & chat support' }
    ]
  }
];

const PricingCard = ({ plan }) => {
  const handleSignup = () => {
    window.location.href = `${BACKEND_URL}/api/signup/`;
  };

  return (
    <div className={`pricing-card ${plan.isPopular ? 'popular' : ''}`} data-testid={`pricing-${plan.id}`}>
      {plan.isPopular && <div className="popular-badge">Most Popular</div>}
      {plan.comingSoon && <div className="coming-soon-badge">Coming Soon</div>}
      <div className="pricing-header">
        <h3 className="plan-name">{plan.name}</h3>
        <div className="plan-price">
          <span className="price">{plan.price}</span>
          <span className="period">{plan.period}</span>
        </div>
        <p className="plan-description">{plan.description}</p>
      </div>
      <div className="pricing-features">
        <ul>
          {plan.features.map((feature, index) => (
            <li key={index} className={feature.included ? 'included' : 'excluded'}>
              <i className={`fa-solid ${feature.included ? 'fa-check' : 'fa-xmark'}`}></i>
              <span dangerouslySetInnerHTML={{ __html: feature.text }} />
            </li>
          ))}
        </ul>
      </div>
      <button 
        className={`btn btn-${plan.buttonVariant} btn-block`} 
        onClick={handleSignup}
      >
        {plan.buttonText}
      </button>
    </div>
  );
};

export const PricingSection = () => {
  return (
    <section className="pricing-section" id="pricing" data-testid="pricing-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-badge">Pricing</span>
          <h2 className="section-title">Choose the Perfect Plan for Your Needs</h2>
          <p className="section-subtitle">Start free and upgrade as you grow. No hidden fees.</p>
        </div>

        <div className="pricing-grid">
          {PLANS.map((plan) => (
            <PricingCard key={plan.id} plan={plan} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
